// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_f8-2";
export var aiChatCartContainerExit = "_f8-4";
export var aiChatContainerLarge = "_f8-0";
export var aiChatContainerSmall = "_f8-1";
export var aiChatIcon = "_f8-6";
export var slideInFromRight = "_f8-3";
export var slideOutToRight = "_f8-5";